import { CultureInfo } from '../culture-info.model';
import { CultureInfoNy } from './ny';

/**
 * @ignore
 */
export const CultureInfoNyMW: CultureInfo = {
  name: 'ny-MW',
  displayName: 'Nyanja (MW)',
  iso3LanguageCode: 'nya',
  iso2LanguageCode: 'ny',
  ietfLanguageTag: 'ny-MW',
  parent: CultureInfoNy
};
